import { RCPOProductGrid } from '../ProductGrid'
import { Filters } from './Filters'
import { RCPO_PAGE_SIZE, useRCPOData } from './hooks/use-rcpo-data'
import Pagination from '@components/Pagination'
import { Article } from '@generated'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { hasSufficientProductData } from './helpers/has-sufficient-product-data'

type RCPOProductOverviewProps = {}

export const RCPOProductOverview: FC<RCPOProductOverviewProps> = () => {
  const { push, query } = useRouter()
  const { fetching, filters, items, totalCount, page } = useRCPOData()
  const itemsWithSufficientData = items.filter((item) => hasSufficientProductData(item))

  return (
    <div className="mx-auto mb-14 grid w-full max-w-[1480px] grid-cols-1 gap-5 px-[10px] lg:mb-24 lg:grid-cols-[340px_1fr]">
      <Filters filters={filters} />
      <div className="w-full">
        <RCPOProductGrid items={itemsWithSufficientData as Article[]} fetching={fetching} />
        <Pagination
          limit={RCPO_PAGE_SIZE}
          currentPage={page}
          totalCount={totalCount}
          setPage={setPage}
        />
      </div>
    </div>
  )

  function setPage(page: number) {
    push(
      {
        query: {
          ...query,
          page,
        },
      },
      undefined,
      {
        shallow: true,
        scroll: true,
      },
    )
  }
}
